import { ReservationService } from "./../services/reservation-service/reservation.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "./../services/projects/projects.service";
import { Component, OnInit } from "@angular/core";
import swal from "sweetalert2";
import { SettingService } from "../services/settings-service/setting.service";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";

@Component({
  selector: "app-price-control",
  templateUrl: "./price-control.component.html",
  styleUrls: ["./price-control.component.css"],
})
export class PriceControlComponent implements OnInit {
  price_control_form: FormGroup;
  backendErrors: any = {};
  projects: any;
  types: any = [];
  buildings: any[];
  designTypes: any = [];
  unitStatuses: any = [
    "Available",
    "Not Available",
    "Blocked",
    "Temp Blocked",
    "Reserved",
    "Pending Finance Action",
    "Re-pricing",
  ];
  finishTypes: any = [
    {
      id: 1,
      name: "Finished",
    },
    {
      id: 2,
      name: "Core and Shell",
    },
    {
      id: 3,
      name: "Core and Shell & Finished",
    },
  ];
  floors: any = [
    { value: 0 },
    { value: 1 },
    { value: 2 },
    { value: 3 },
    { value: 4 },
    { value: 5 },
    { value: 6 },
    { value: 7 },
  ];

  selectedUnits: any[] = [];
  unitSerialInput: string = "";
  private _unitSearchCache: any[] = [];
  unitsCount: number | null = null;
  submitSuccess: boolean = false;
  adjacentByUnitId: { [unitId: number]: any } = {};
  adjacentLoadingByUnitId: { [unitId: number]: boolean } = {};
  activeAdjacentUnitId: number | null = null;

  constructor(
    private projectService: ProjectsService,
    private settingService: SettingService,
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService,
    private fb: FormBuilder,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    this.getProjects();
    this.getFinishTypes();
  }

  unitSerialSource = (keyword: any): any => {
    if (!keyword) {
      return Observable.of([]);
    }
    const data = this.buildUnitSearchPayload(keyword);
    return this.projectService.searchAvilableUnits(data).map((res: any) => {
      this._unitSearchCache = res || [];
      if (!res || res.length === 0) {
        return [];
      }
      return res
        .filter(u => !this.selectedUnits.find(s => s.id === u.id))
        .map(u => `${u.serial} (${u.project ? u.project.name : ""})`);
    });
  };

  onUnitSerialSelected(value: string) {
    if (!value) return;
    const unit = this._unitSearchCache.find(
      u => `${u.serial} (${u.project ? u.project.name : ""})` === value
    );
    if (unit && !this.selectedUnits.find(u => u.id === unit.id)) {
      this.selectedUnits.push(unit);
      setTimeout(() => {
        this.unitSerialInput = "";
      }, 0);
    }
  }

  removeUnit(unit: any) {
    this.selectedUnits = this.selectedUnits.filter(u => u.id !== unit.id);
    delete this.adjacentByUnitId[unit.id];
    delete this.adjacentLoadingByUnitId[unit.id];
    if (this.activeAdjacentUnitId === unit.id) {
      this.activeAdjacentUnitId = null;
    }
  }

  viewAdjacentUnits(unit: any) {
    if (!unit || unit.id == null) return;
    const id = unit.id;
    if (this.activeAdjacentUnitId === id) {
      this.activeAdjacentUnitId = null;
      return;
    }
    if (this.adjacentByUnitId[id]) {
      this.activeAdjacentUnitId = id;
      return;
    }
    this.adjacentLoadingByUnitId[id] = true;
    this.projectService.getAdjacentUnits(id).subscribe(
      (res: any) => {
        this.adjacentByUnitId[id] = res;
        this.activeAdjacentUnitId = id;
        this.adjacentLoadingByUnitId[id] = false;
      },
      (err) => {
        this.adjacentLoadingByUnitId[id] = false;
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getActiveAdjacentUnit() {
    if (this.activeAdjacentUnitId == null) return null;
    return this.selectedUnits.find(u => u.id === this.activeAdjacentUnitId) || null;
  }

  getAdjacentUnitPrices(adjacentUnit: any): { name: string; price: number }[] {
    if (!adjacentUnit) return [];
    if (adjacentUnit.price != null) {
      return [{ name: "Price", price: adjacentUnit.price }];
    }
    const map = adjacentUnit.finishing_types_price_per_meter;
    if (!map) return [];
    return Object.keys(map)
      .map(key => map[key])
      .filter(entry => entry && entry.price != null)
      .map(entry => ({
        name: entry.finishing_type_name,
        price: entry.price,
      }));
  }

  getFinishTypes() {
    this.settingService.getFinishingTypes().subscribe(
      (data) => {
        this.finishTypes = data;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getBuildings() {
    this.buildings = [];
    this.price_control_form.get("building").setValue([]);
    this.projectService
      .getBuildings(this.price_control_form.get("project_id").value)
      .subscribe(
        (data: any) => {
          this.buildings = data;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  getdesignTypes() {
    this.slimLoadingBarService.start();
    this.price_control_form.get("design_type").setValue("");
    this.designTypes = [];

    this.projectService
      .getDesignTypes(this.price_control_form.get("project_id").value)
      .subscribe(
        (data) => {
          this.designTypes = data;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  createForm() {
    this.price_control_form = this.fb.group({
      project_id: ["", Validators.required],
      unit_type_id: [[]],
      design_type: [""],
      unit_status: [[]],
      floor: [[]],
      building: [[]],
      block: [""],
      area: [""],
      finishing_type: [null],
      price_type: ["Percentage"],
      price_value: [null],
      comment: [null],
    });
    this.backendErrors = {};
    this.selectedUnits = [];
    this.unitSerialInput = "";
    this._unitSearchCache = [];
    this.adjacentByUnitId = {};
    this.adjacentLoadingByUnitId = {};
    this.activeAdjacentUnitId = null;
  }

  getFieldError(fieldName: string) {
    const control = this.price_control_form.get(fieldName);

    if (!control) {
      return "";
    }

    if (this.backendErrors[fieldName]) {
      return this.backendErrors[fieldName];
    }

    if (fieldName === "project_id" &&
        control.hasError("required") &&
        (control.dirty || control.touched)) {
      switch (fieldName) {
        case "project_id":
          return "Project is required";
        default:
          return "This field is required";
      }
    }

    return "";
  }

  clearBackendErrors() {
    this.backendErrors = {};
  }

  applyBackendValidationErrors(err) {
    this.clearBackendErrors();

    if (!(err && err.error && err.error.errors)) {
      return false;
    }

    Object.keys(err.error.errors).forEach((fieldName) => {
      const fieldErrors = err.error.errors[fieldName];
      const control = this.price_control_form.get(fieldName);

      if (fieldErrors && fieldErrors.length) {
        this.backendErrors[fieldName] = fieldErrors[0];
      }

      if (control) {
        control.markAsTouched();
      }
    });

    return true;
  }

  getProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (res: any) => {
        this.projects = res;
        this.createForm();
      },
      (err) => console.log(err)
    );
  }

  getUnitTypes() {
    this.slimLoadingBarService.start();
    this.types = [];
    this.price_control_form.get("unit_type_id").setValue([]);
    this.projectService
      .getUnitTypes(this.price_control_form.get("project_id").value)
      .subscribe(
        (data) => {
          this.types = data;
          console.log(this.types);
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  buildPayload() {
    const formValue = this.price_control_form.value;

    return {
      project_id: +formValue.project_id,
      design_type: formValue.design_type,
      unit_type_id: formValue.unit_type_id || [],
      unit_status: formValue.unit_status || [],
      floor: formValue.floor || [],
      building: formValue.building || [],
      block: formValue.block || "",
      area: formValue.area || "",
      unit_id: this.selectedUnits.map(u => u.id),
      finishing_type: formValue.finishing_type,
      price_type: formValue.price_type,
      price_value: formValue.price_value,
      comment: formValue.comment,
    };
  }

  buildUnitSearchPayload(serial: string) {
    const formValue = this.price_control_form ? this.price_control_form.value : {};
    return {
      unit_serial: serial,
      project_id: formValue.project_id ? +formValue.project_id : null,
      design_type: formValue.design_type || null,
      unit_type_id: formValue.unit_type_id || [],
      unit_status: formValue.unit_status || [],
      floor: formValue.floor || [],
      building: formValue.building || [],
      block: formValue.block || "",
      area: formValue.area || "",
    };
  }

  extractAffectedUnitsCount(res: any) {
    if (typeof res === "number") {
      return res;
    }

    if (typeof res === "string") {
      return res;
    }

    if (!res) {
      return 0;
    }

    return (
      res.affected_units_count ||
      res.affected_units ||
      res.units_count ||
      res.count ||
      (res.data && res.data.affected_units_count) ||
      (res.data && res.data.affected_units) ||
      (res.data && res.data.units_count) ||
      (res.data && res.data.count) ||
      0
    );
  }

  getUnitsCount() {
    this.submitSuccess = false;
    this.clearBackendErrors();
    const payload = { ...this.buildPayload(), is_review: true };
    this.slimLoadingBarService.start();
    this.projectService.requestUnitPriceChange(payload).subscribe(
      (res: any) => {
        this.unitsCount = this.extractAffectedUnitsCount(res);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        if (!this.applyBackendValidationErrors(err)) {
          this.errorHandlerService.handleErorr(err);
        }
        this.slimLoadingBarService.complete();
      }
    );
  }

  submit() {
    this.clearBackendErrors();
    this.slimLoadingBarService.start();
    this.projectService.requestUnitPriceChange(this.buildPayload()).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        swal(res.message || "Success", "", "success").then(() => {
          this.unitsCount = null;
          this.submitSuccess = true;
          this.createForm();
        });
      },
      (err) => {
        if (!this.applyBackendValidationErrors(err)) {
          this.errorHandlerService.handleErorr(err);
        }
        this.slimLoadingBarService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/price-control/price-control.component.ts